export const PREDICTION_LEVEL_LIST = 'PREDICTION_LEVEL_LIST';
export const PREDICTION_LEVEL_LIST_SUCCESS = 'PREDICTION_LEVEL_LIST_SUCCESS';
export const PREDICTION_LEVEL_LIST_ERROR = 'PREDICTION_LEVEL_LIST_ERROR';

export const ADD_PREDICTION_LEVEL = 'ADD_PREDICTION_LEVEL';
export const ADD_PREDICTION_LEVEL_SUCCESS = 'ADD_PREDICTION_LEVEL_SUCCESS';
export const ADD_PREDICTION_LEVEL_ERROR = 'ADD_PREDICTION_LEVEL_ERROR';

export const PREDICTION_LEVEL_DETAILS = 'PREDICTION_LEVEL_DETAILS';
export const PREDICTION_LEVEL_DETAILS_SUCCESS = 'PREDICTION_LEVEL_DETAILS_SUCCESS';
export const PREDICTION_LEVEL_DETAILS_ERROR = 'PREDICTION_LEVEL_DETAILS_ERROR';

export const PREDICTION_LEVEL_UPDATE = 'PREDICTION_LEVEL_UPDATE';
export const PREDICTION_LEVEL_UPDATE_SUCCESS = 'PREDICTION_LEVEL_UPDATE_SUCCESS';
export const PREDICTION_LEVEL_UPDATE_ERROR = 'PREDICTION_LEVEL_UPDATE_ERROR';

export const DELETE_PREDICTION_LEVEL = 'DELETE_PREDICTION_LEVEL';
export const DELETE_PREDICTION_LEVEL_ERROR = 'DELETE_PREDICTION_LEVEL_ERROR';
export const DELETE_PREDICTION_LEVEL_SUCCESS = 'DELETE_PREDICTION_LEVEL_SUCCESS';